import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const StyledTable = styled.table((props) => ({
  textAlign: 'center',
  borderCollapse: 'separate',
  borderSpacing: '0px 8px',
  width: '100%',
  'thead > tr': {
    height: '2rem',
    th: {
      border: 'none !important',
      verticalAlign: 'middle',
      '&:first-child': {
        borderTopRightRadius: '0.5rem',
      },
      '&:last-child': {
        borderTopLeftRadius: '0.5rem',
      },
    },
    td: {
      border: 'none !important',
    },
  },
  tbody: {
    'th,td': {
      border: 'none',
    },
    tr: {
      boxShadow: '0 0 0.25rem 0.125rem rgba(0, 0, 0, 0.075)',
      borderRadius: '8px',
      height: '40px',
      '&:hover': {
        backgroundColor: colors.backgroundLightWhite,
      },
      td: {
        ':first-child': {
          borderRadius: '0 8px 8px 0',
        },
        ':last-child': {
          borderRadius: '8px 0 0 8px',
        },
        verticalAlign: 'middle',
      },
    },
  },
}));

export { StyledTable };
